var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateContent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.55522 16.2607L11.8649 16.1308C12.163 16.127 12.4035 15.8858 12.4063 15.5876L12.5398 1.28572C12.5426 0.980915 12.2963 0.7323 11.9915 0.7323H1.54831C1.24549 0.7323 1 0.977785 1 1.28061V15.7124C1 16.0179 1.24972 16.2645 1.55522 16.2607Z",
    stroke: "#002C79",
    strokeWidth: 1.24844,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.38037 3.90552H7.82776",
    stroke: "#002C79",
    strokeWidth: 1.24844,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.38037 6.28485H9.72697",
    stroke: "#002C79",
    strokeWidth: 1.24844,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.38037 9.45917H8.14032",
    stroke: "#002C79",
    strokeWidth: 1.24844,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateContent);
export default __webpack_public_path__ + "static/media/CreateContent.2833af000240342b979fb180d7966432.svg";
export { ForwardRef as ReactComponent };